import * as React from 'react';
import { Spinner } from "reactstrap";

class DABInlineLoading extends React.Component  {
  render() {
		return (
		<div className="custom-loader-spiiner" >
				<Spinner size="sm" type="grow" color="primary" />
				<Spinner size="sm" type="grow" color="secondary" />
				<Spinner size="sm" type="grow" color="success" />
				<Spinner size="sm" type="grow" color="danger" />
				<Spinner size="sm" type="grow" color="warning" />
				<Spinner size="sm" type="grow" color="info" />
		</div>
	)}
}

export default DABInlineLoading;